import React, { useState } from 'react';
import { Button, Col, Form, Input, Row, Select } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { StaffRoleDict, StaffStatusDict } from 'src/services/DepartmentAdminService';
import I18N from 'src/services/I18NService';
import { IStaffSearch } from 'src/entity/DepartmentEntity';
import { isString } from 'lodash';
const { Option } = Select;

interface IProps extends FormComponentProps<{}> {
  defaultQuery: Partial<IStaffSearch>,
  loading: boolean,
  onSearch: (query: Partial<IStaffSearch>) => void,
}

const DepartmentUserSearchComp: React.FC<IProps> = (props) => {
  const { defaultQuery, loading, form, onSearch } = props;
  const { getFieldDecorator } = form;

  const [queryParam, setQueryParam] = useState(defaultQuery);
  const formItemStyle = {marginLeft: 30, marginBottom: 0};

  const handleSearch = () => {
    const {code, fullname, mobile, role, is_active} = form.getFieldsValue();
    // 将表单输入项 => 接口需要的类型
    const query: Partial<IStaffSearch> = {
      code,
      fullname,
      mobile,
      role,
      // 下拉选择控件不支持 boolean，需要手动转化
      is_active: is_active  === 'true' ? true : (is_active  === 'false' ? false : undefined),
    };
    onSearch(query);
  }

  const handleReset = () => {
    const result = new IStaffSearch(20);
    setQueryParam(result);
    form.resetFields();
  }


  return (
    <Form className="mdd-search-form">
      <Row>
        <Col span={5}>
          <Form.Item label={I18N.get('common_name')} style={{marginBottom: 0}}>
            {getFieldDecorator('fullname', {
              initialValue: queryParam.fullname,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_name')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item label={I18N.get('departmentAdmin_staff_code')} style={formItemStyle}>
            {getFieldDecorator('code', {
              initialValue: queryParam.code,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('departmentAdmin_staff_code')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item label={I18N.get('common_mobile')} style={formItemStyle}>
            {getFieldDecorator('mobile', {
              initialValue: queryParam.mobile,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_mobile')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item label={I18N.get('userAdmin_role')} style={formItemStyle}>
            {getFieldDecorator('role', {
              initialValue: queryParam.role,
            })(
              <Select
                allowClear={true}
                placeholder={`${I18N.get('common_choose')}${I18N.get('userAdmin_role')}`}
              >
                {StaffRoleDict.map(item => (
                  <Option key={String(item.value)} value={String(item.value)}>{I18N.get(item.key)}</Option>
                ))}
              </Select>
              
            )}
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label={I18N.get('common_status')} style={formItemStyle}>
            {getFieldDecorator('is_active', {
              initialValue: isString(queryParam.is_active) ? String(queryParam.is_active) : undefined,
            })(
              <Select
                allowClear={true}
                placeholder={`${I18N.get('common_choose')}${I18N.get('common_status')}`}
              >
                {StaffStatusDict.map(item => (
                  <Option key={String(item.value)} value={String(item.value)}>{I18N.get(item.key)}</Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row type="flex" justify="center" style={{marginTop: 16}}>
        <Button
          type="primary"
          onClick={handleSearch}
          loading={loading}
        >{I18N.get('common_search')}</Button>
        <Button
          onClick={handleReset}
          style={{marginLeft: 16}}
        >{I18N.get('common_clear')}</Button>
      </Row>
    </Form>
    
  )
}
const WrappedDepartmentUserSearchComp = Form.create<IProps>()(DepartmentUserSearchComp)
const DepartmentUserSearch = React.memo(WrappedDepartmentUserSearchComp);
export default DepartmentUserSearch;


// WEBPACK FOOTER //
// ./src/components/views/DepartmentAdmin/User/UserSearch.tsx